import { useEffect, useRef } from "react";

interface AggregationSubscription {
  subscribe: () => void;
  unsubscribe: () => void;
}

export function useAggregationSubscription(
  aggregations: AggregationSubscription
) {
  const subscriptionRef = useRef<AggregationSubscription>({
    subscribe: aggregations.subscribe,
    unsubscribe: aggregations.unsubscribe,
  });

  useEffect(() => {
    // Update subscription methods if they change
    subscriptionRef.current = {
      subscribe: aggregations.subscribe,
      unsubscribe: aggregations.unsubscribe,
    };

    // Subscribe when effect runs
    subscriptionRef.current.subscribe();

    // Cleanup subscription on unmount
    return () => {
      subscriptionRef.current.unsubscribe();
    };
  }, [aggregations.subscribe, aggregations.unsubscribe]);

  return subscriptionRef.current;
}
